import { ChangeDetectionStrategy, Component, inject, Input } from '@angular/core';
import { AuthService, LinksService } from '@isophi/core-legacy';
import { IconService } from '@isophi/core-ui';
import { IndividualChildResultPreview, skeletonTransitionAnimation } from '@isophi/teachers-shared';
import { Group } from '@isophi/teachers-shared';

import { environment } from '../../../../../environments/environment';
import { RouterLinkFactory } from '../../../../core/router/router-link.factory';

@Component({
    selector: 'app-report-preview',
    templateUrl: './report-preview.component.html',
    styleUrls: ['./report-preview.component.scss'],
    changeDetection: ChangeDetectionStrategy.OnPush,
    animations: [skeletonTransitionAnimation],
    standalone: false
})
export class ReportPreviewComponent {
  private readonly linksService = inject(LinksService);

  @Input() childResults: IndividualChildResultPreview[];

  @Input() childResultsCompleted: IndividualChildResultPreview[];

  materialServer = environment.materialServer;

  showCompleted = false;

  protected readonly dadUrl = this.linksService.getDadAppUrl();

  constructor(public icons: IconService, private routerLinkFactory: RouterLinkFactory, private authService: AuthService) {}

  switchResults(): void {
    this.showCompleted = !this.showCompleted;
  }

  getResults(): IndividualChildResultPreview[] {
    if (this.showCompleted) {
      return this.childResultsCompleted;
    }
    return this.childResults;
  }

  getResultLink(uuid: string): (string | number)[] {
    return this.routerLinkFactory.childReport(uuid);
  }

  getChildListLink(): (string | number)[] {
    return this.routerLinkFactory.childList();
  }

  getContinueTestDadUrl(resultUuid: string, childUuid: string) {
    return this.linksService.getDadAppUrl({ redirect: `/test/continue/${resultUuid}/${childUuid}/0` });
  }

  getChildGroupTooltip(groups: Group[]): string {
    return groups.map((g) => g.name).join(', ');
  }
}
